import { render } from "./MLText.vue?vue&type=template&id=3f11a059&scoped=true"
import script from "./MLText.vue?vue&type=script&lang=js"
export * from "./MLText.vue?vue&type=script&lang=js"

import "./MLText.vue?vue&type=style&index=0&id=3f11a059&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.22_vue@3.5.22_typescript@4.1.6__webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f11a059"]])

export default __exports__